import { defaultTheme, FONTS_SIZE, getLineHeight } from "./defaultTheme";
import { EMPRESAS } from "../shared/utils/Constantes";

const palettePardini = {
  primary: {
    main: "#D31245",
    light: "rgba(211,18,69,0.1)",
    dark: "#B10033"
  },
  secondary: {
    main: "#656D75",
    dark: "#45514A"
  },
  neutral: {
    main: "#C0C6D6",
    light: "rgba(101,109,117,0.1)",
    dark: "#656D75"
  },
  background: {
    main: "#FFFFFF"
  },
  info: {
    main: "#FFAB4A"
  },
  success: {
    main: "#5EC0C7"
  },
  alternativePrimary: {
    main: "rgba(211, 18, 69, 0.05)"
  }
};

const paletteMyPardini = {
  ...palettePardini,
  primary: {
    main: "#23144D",
    light: "rgba(191, 67, 171, 0.2)",
    dark: "#656D75"
  },
  secondary: {
    main: "#BF43AB",
    light: "rgba(109,110,113,0.1)",
    dark: "#7b286f"
  }
};

const customCssProps = {
  subtitle5: ".subtitle5",
  bolaVermelha: ".bolaVermelha",
  muiSelected: "&.Mui-selected",
  muiFocused: "&.Mui-focused",
  muiNotchedOutlineFocused: "&.Mui-focused $notchedOutline",
  highlight: ".highlight",
  linkButton: ".linkButton",
  rodape: ".rodape",
  compartilhar: ".compartilhar",
  tituloH2PesquisaMultipla: ".tituloH2PesquisaMultipla",
  textoAtencaoVisualizacaoMultipla: ".textoAtencaoVisualizacaoMultipla",
  indicator: ".indicator",
  scrollMarginTop: ".scrollMarginTop"
};

export const obterTemaEmpresa = (empresa, ehMyPardini) => {
  if (ehMyPardini) {
    const themeMyPardini = defaultTheme(paletteMyPardini);

    themeMyPardini.overrides.MuiOutlinedInput.root.color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.overrides.MuiTab.root[customCssProps.muiSelected].color =
      themeMyPardini.palette.secondary.main;
    themeMyPardini.overrides.MuiFormLabel.root[customCssProps.muiFocused].color =
      themeMyPardini.palette.secondary.main;
    themeMyPardini.overrides.MuiOutlinedInput.root[
      customCssProps.muiNotchedOutlineFocused
    ].borderColor = themeMyPardini.palette.secondary.main;

    themeMyPardini.typography.h1.color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.typography.h2.color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.typography.h3.color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.typography.h4.color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.typography.h5.color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.typography.body1.color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.typography.tableCell.color = themeMyPardini.palette.neutral.dark;

    themeMyPardini.global[customCssProps.subtitle5].color = themeMyPardini.palette.neutral.dark;
    themeMyPardini.global[customCssProps.subtitle5].lineHeight = getLineHeight(
      FONTS_SIZE.sizes.size5
    );

    themeMyPardini.global[customCssProps.linkButton].color = themeMyPardini.palette.secondary.main;
    themeMyPardini.global[customCssProps.compartilhar].color =
      themeMyPardini.palette.secondary.main;
    themeMyPardini.global[customCssProps.tituloH2PesquisaMultipla].color =
      themeMyPardini.palette.secondary.main;
    themeMyPardini.global[customCssProps.textoAtencaoVisualizacaoMultipla].color =
      themeMyPardini.palette.secondary.main;
    themeMyPardini.global[customCssProps.rodape].display = "none";
    themeMyPardini.global[customCssProps.scrollMarginTop] = { scrollMarginTop: "5rem" };

    return themeMyPardini;
  }

  if (empresa.id === EMPRESAS.PARDINI.id) {
    return defaultTheme(palettePardini);
  }

  const paletteEmpresa = {
    ...palettePardini,
    primary: {
      main: empresa.corPrimariaMain ?? palettePardini.primary.main,
      light: empresa.corPrimariaLight ?? palettePardini.primary.light,
      dark: empresa.corPrimariaDark ?? palettePardini.primary.dark
    },
    secondary: {
      main: empresa.corSecundariaMain ?? palettePardini.secondary.main,
      light: empresa.corSecundariaLight ?? palettePardini.secondary.light,
      dark: empresa.corSecundariaDark ?? palettePardini.secondary.dark
    },
    alternativePrimary: {
      main: empresa.corAlternativaPrimariaMain ?? palettePardini.alternativePrimary.main
    }
  };

  const temaEmpresa = defaultTheme(paletteEmpresa);

  switch (empresa.id) {
    case EMPRESAS.ECOAR.id:
    case EMPRESAS.ODIVANIA.id:
    case EMPRESAS.LABCLASS.id:
      temaEmpresa.overrides.MuiOutlinedInput.root.color = temaEmpresa.palette.neutral.dark;

      temaEmpresa.typography.h1.color = temaEmpresa.palette.neutral.dark;
      temaEmpresa.typography.h2.color = temaEmpresa.palette.neutral.dark;
      temaEmpresa.typography.h3.color = temaEmpresa.palette.neutral.dark;
      temaEmpresa.typography.h4.color = temaEmpresa.palette.neutral.dark;
      temaEmpresa.typography.h5.color = temaEmpresa.palette.neutral.dark;
      temaEmpresa.typography.body1.color = temaEmpresa.palette.neutral.dark;
      temaEmpresa.typography.tableCell.color = temaEmpresa.palette.neutral.dark;

      temaEmpresa.global[customCssProps.subtitle5].color = temaEmpresa.palette.neutral.dark;
      temaEmpresa.global[customCssProps.subtitle5].lineHeight = getLineHeight(
        FONTS_SIZE.sizes.size5
      );
      temaEmpresa.global[customCssProps.bolaVermelha] = {};
      temaEmpresa.global[customCssProps.highlight].backgroundColor =
        temaEmpresa.palette.secondary.light;
      temaEmpresa.global[customCssProps.linkButton].color = temaEmpresa.palette.secondary.main;
      temaEmpresa.global[customCssProps.rodape].backgroundColor =
        temaEmpresa.palette.secondary.dark;
      temaEmpresa.global[customCssProps.compartilhar].color = temaEmpresa.palette.secondary.main;
      if (empresa.id !== EMPRESAS.LABCLASS.id) {
        temaEmpresa.global[customCssProps.tituloH2PesquisaMultipla].color =
          temaEmpresa.palette.secondary.main;
        temaEmpresa.global[customCssProps.textoAtencaoVisualizacaoMultipla].color =
          temaEmpresa.palette.secondary.main;
      }
      temaEmpresa.global[customCssProps.scrollMarginTop] = { scrollMarginTop: "5rem" };
      break;
    case EMPRESAS.CMNG.id:
      temaEmpresa.global[customCssProps.rodape].backgroundColor = temaEmpresa.palette.primary.main;
      temaEmpresa.global[customCssProps.indicator].backgroundColor =
        temaEmpresa.palette.secondary.main;
      temaEmpresa.global[customCssProps.scrollMarginTop] = { scrollMarginTop: "5rem" };
      break;
    case EMPRESAS.PADRAO.id:
      temaEmpresa.global[customCssProps.scrollMarginTop] = { scrollMarginTop: "5rem" };
  }
  return temaEmpresa;
};
